import styles from './ContentContainer.module.scss';
import PropTypes from 'prop-types';

const ContentContainer = (props) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>{props.children}</div>
        </div>
    );
};

ContentContainer.propTypes = {
    children: PropTypes.any
};
export default ContentContainer;
